import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, query, where, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase/firebase';
import { auth } from '../firebase/firebase';

const campaignsCollectionRef = collection(db, 'campaigns');

// Add this function to initialize campaigns collection if needed
export const initializeCampaignsIfNeeded = async () => {
  try {
    const userId = auth.currentUser?.uid;
    
    if (!userId) {
      throw new Error('User not authenticated');
    }
    
    // Create a simple query to check if collection exists and accessible
    const q = query(
      campaignsCollectionRef, 
      where("userId", "==", userId),
      limit(1)
    );
    
    await getDocs(q);
    return true;
  } catch (error) {
    // If error is permission denied or collection doesn't exist
    console.log("Attempting to create initial campaign document");
    
    try {
      // Create a sample campaign to initialize the collection
      await addCampaign({
        title: "Welcome Campaign",
        subject: "Welcome to Mejlkampanj",
        body: "<p>This is a sample campaign to get you started.</p>"
      });
      return true;
    } catch (innerError) {
      console.error("Failed to initialize campaigns collection", innerError);
      throw innerError;
    }
  }
};

export const getCampaigns = async () => {
  try {
    // Get the current user ID
    const userId = auth.currentUser?.uid;
    
    if (!userId) {
      throw new Error('User not authenticated');
    }
    
    // Try to initialize if needed
    await initializeCampaignsIfNeeded();
    
    // Create a query against the collection to only get this user's campaigns, ordered by creation date
    const q = query(
      campaignsCollectionRef, 
      where("userId", "==", userId),
      orderBy("createdAt", "desc")
    );
    
    const querySnapshot = await getDocs(q);
    
    return querySnapshot.docs.map(doc => {
      const data = doc.data();
      // Format the timestamp if it exists
      const createdAt = data.createdAt?.toDate ? 
        data.createdAt.toDate() : 
        data.createdAt;
        
      return {
        id: doc.id,
        title: data.title || '',
        subject: data.subject || '',
        body: data.body || '',
        createdAt,
        userId: data.userId
      };
    });
  } catch (error) {
    console.error("Error getting campaigns: ", error);
    throw error;
  }
};

export const addCampaign = async (campaign) => {
  try {
    // Add userId and createdAt to the campaign data
    const enhancedCampaign = {
      ...campaign,
      userId: auth.currentUser?.uid,
      createdAt: new Date()
    };
    
    return await addDoc(campaignsCollectionRef, enhancedCampaign);
  } catch (error) {
    console.error("Error adding campaign: ", error);
    throw error;
  }
};

export const updateCampaign = async (id, updatedCampaign) => {
  try {
    const campaignDoc = doc(db, 'campaigns', id);
    
    // Remove the id field as it shouldn't be part of the document data
    const { id: _, ...dataToUpdate } = updatedCampaign;
    
    return await updateDoc(campaignDoc, dataToUpdate);
  } catch (error) {
    console.error("Error updating campaign: ", error);
    throw error;
  }
};

export const deleteCampaign = async (id) => {
  try {
    const campaignDoc = doc(db, 'campaigns', id);
    return await deleteDoc(campaignDoc);
  } catch (error) {
    console.error("Error deleting campaign: ", error);
    throw error;
  }
};
